import { jsx as _jsx } from "react/jsx-runtime";
import { App } from 'antd';
import { fetchTrsx, getLanguageFromTrsx } from 'api/project-api';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import AlertWithButton from 'components/AlertWithButton';
import { useSubModeTutorial } from '../../../contexts/subModeTutorial';
import { useEditorContext } from '../../../contexts/projectSignal';
const ResetTab = ({ onCancel, editorController }) => {
    const { session } = useSession();
    const { message } = App.useApp();
    const { retrieveTutorialState } = useSubModeTutorial();
    const { projectSignal } = useEditorContext();
    const turnOffsubtitleRevision = async () => {
        const trsx = await fetchTrsx(session.connection, projectSignal.value.id, 'currentTrsx');
        if (trsx.isSuccess()) {
            const language = getLanguageFromTrsx(trsx.get().content);
            editorController.importTrsx({
                content: trsx.get().content,
                etag: trsx.get().etag,
                label: editorController.label,
                language,
            }, true, projectSignal.value, true);
            void message.success(txt('captionsRemoved'));
        }
        else {
            void message.error(txt('removeCaptionsFailed'));
            global.logger.error('Failed to reset captions', {}, trsx.err());
        }
        onCancel();
    };
    return (_jsx(AlertWithButton, { message: txt('subtitleResetWarning'), type: "warning", buttonType: "danger", disabled: retrieveTutorialState() === 'running', onClick: turnOffsubtitleRevision, buttonText: txt('switchToTranscription') }));
};
export default ResetTab;
